import type { AuthSession, AuthTenant, AuthUser, LoginResult } from '@/domain/entities/auth.entity'
import type {
  AuthTenantDto,
  LoginResponseDto,
  MeResponseDto,
  PermissionDto,
  SelectTenantResponseDto,
} from './auth.dto'

function toTenant(dto: AuthTenantDto): AuthTenant {
  return { id: dto.id, name: dto.name, picture: dto.picture ?? undefined }
}

function toPermissions(list?: PermissionDto[] | null): string[] {
  if (!list) return []
  return list.map((p) => (typeof p === 'string' ? p : p.code))
}

export const authMapper = {
  toLoginResult(dto: LoginResponseDto): LoginResult {
    return {
      loginToken: dto.login_token,
      tenants: (dto.tenants ?? []).map(toTenant),
    }
  },

  toSession(dto: SelectTenantResponseDto): AuthSession {
    return {
      accessToken: dto.access_token,
      refreshToken: dto.refresh_token ?? undefined,
      expiresIn: dto.expires_in,
    }
  },

  toUser(dto: MeResponseDto): AuthUser {
    // Role bisa berupa string ("OWNER") atau objek { id, name }.
    const roleName = typeof dto.role === 'string' ? dto.role : (dto.role?.name ?? undefined)
    const roleId = typeof dto.role === 'object' && dto.role ? dto.role.id : ''
    // /me tak selalu mengirim is_superadmin → kenali SUPERADMIN dari nama role.
    const isSuperadmin = Boolean(dto.is_superadmin) || roleName === 'SUPERADMIN'
    return {
      id: dto.user_id ?? dto.id ?? '',
      username: dto.username,
      name: dto.name,
      isSuperadmin,
      tenant: dto.tenant ? toTenant(dto.tenant) : undefined,
      role: roleName ? { id: roleId, name: roleName } : undefined,
      permissions: toPermissions(dto.permissions),
    }
  },
}
